import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MajorProjectStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface MajorProjectStatusProps {
  value: MajorProjectStatusEnum;
}

const MajorProjectStatusColor = {
  [MajorProjectStatusEnum.Ready]: '#D19500',
  [MajorProjectStatusEnum.InProduction]: '#06B6D4',
  [MajorProjectStatusEnum.Exception]: '#DC2626',
  [MajorProjectStatusEnum.Delivered]: '#22C55E',
  [MajorProjectStatusEnum.OnHold]: '#A855F7',
  [MajorProjectStatusEnum.Canceled]: '#737373',
  [MajorProjectStatusEnum.RequiredBooking]: '#EC4899',
  [MajorProjectStatusEnum.DeliveryBooked]: '#3B82F6',
};
export const MajorProjectStatus: FC<MajorProjectStatusProps> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'majorProjects' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={MajorProjectStatusColor[value]}
    />
  );
};
